import { render, staticRenderFns } from "./paymsuspendlist.vue?vue&type=template&id=0b3f988b&"
import script from "./paymsuspendlist.vue?vue&type=script&lang=js&"
export * from "./paymsuspendlist.vue?vue&type=script&lang=js&"
import style0 from "./paymsuspendlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports